import Root from "../components/layout/Root";
import Contact from "../pages/Contact";
import Numbers from "../pages/Numbers";
import About from "../pages/About";
import Catalog from "../pages/Catalog";
import NotFound from "../pages/NotFound";
import Stores from "../pages/Stores";
import OrderResult from "../pages/OrderResult";
import Order from "../pages/Order";

const routes = [
  {
    path: "/",
    element: <Root />,
    children: [
      {
        path: "",
        element: <Numbers />,
      },
      {
        path: "/catalog",
        element: <Catalog />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/stores",
        element: <Stores />,
      },
      {
        path: "/order-result",
        element: <OrderResult />,
      },
      {
        path: "/order",
        element: <Order />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;
